import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { ServicePlanCategory } from 'src/features/servicePlanCategory/utils/types';
import DeleteServicePlanCategoryFormModal
    from 'src/features/servicePlanCategory/components/forms/DeleteServicePlanFormCategoryModal';
import UpdateServicePlanCategoryFormModal
    from 'src/features/servicePlanCategory/components/forms/UpdateServicePlanCategoryFormModal';
import { servicePlanCategoriesMessages } from 'src/features/servicePlanCategory/utils/messages';

export default function CellServicePlanCategoryActions({ row }: CellContext<ServicePlanCategory, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateServicePlanCategoryFormModal
                        semantics={{ entryName: formatMessage(servicePlanCategoriesMessages.category).toLowerCase() }}
                        selectedServicePlanCategory={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateServicePlanCategoryFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteServicePlanCategoryFormModal selectedServicePlanCategory={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteServicePlanCategoryFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
